import { render, staticRenderFns } from "./RemoveItemButton.vue?vue&type=template&id=3219ee74&scoped=true&"
import script from "./RemoveItemButton.vue?vue&type=script&lang=js&"
export * from "./RemoveItemButton.vue?vue&type=script&lang=js&"
import style0 from "./RemoveItemButton.vue?vue&type=style&index=0&id=3219ee74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3219ee74",
  null
  
)

component.options.__file = "RemoveItemButton.vue"
export default component.exports